
  import {defineComponent} from 'vue';
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import {mapGetters} from "vuex";
  import router from "@/router";

  export default defineComponent({
    name: 'payment-success-bridge-view',
    mounted(): void {
      const nextRoute = new NamedRouting('PaymentSuccessView',
          {
            orderType: this.$route.query.orderType,
            resultId: this.$route.query.resultId
          });
      if (this.isApp) {
        router.replace(nextRoute);
      } else {
        window.opener.vm.productOrderComponent.moveToPaymentSuccessPage(nextRoute);
        window.close();
      }
    },
    computed: {
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    }
  });
